/**
 * @generated SignedSource<<968d5daeb93593ab1eea04740cc12e98>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type InfectopharmCountry = "Deutschland" | "Oesterreich" | "%future added value";
export type InfectopharmRole = "AlliedHealthProfessionals" | "Apothecary" | "Dentist" | "Doccheck" | "Doctor" | "MTA" | "Midwife" | "Other" | "PKA" | "PTA" | "PharmaceuticalEngineer" | "%future added value";
export type RegistrationDisplayLocation = "Profile" | "Registration" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type NewsletterFormPart_BrandFragment$data = {
  readonly newsletters: ReadonlyArray<{
    readonly countries: ReadonlyArray<InfectopharmCountry>;
    readonly description: string;
    readonly id: string;
    readonly limitToRoles: ReadonlyArray<InfectopharmRole>;
    readonly name: string;
    readonly registrationDisplayLocations: ReadonlyArray<RegistrationDisplayLocation>;
  }>;
  readonly " $fragmentType": "NewsletterFormPart_BrandFragment";
};
export type NewsletterFormPart_BrandFragment$key = {
  readonly " $data"?: NewsletterFormPart_BrandFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"NewsletterFormPart_BrandFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NewsletterFormPart_BrandFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Newsletter",
      "kind": "LinkedField",
      "name": "newsletters",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "limitToRoles",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "registrationDisplayLocations",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "countries",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Brand",
  "abstractKey": null
};

(node as any).hash = "baa347966f1db9a35e47e51a14ae5043";

export default node;
